module.exports = __webpack_public_path__ + "img/file.d936888d.svg";